import { SESSIONS_TEST_IDS } from '@/components/admin/sessions/contracts';
import { SEARCH_MINIMUM_SENTENCE } from '@/lib/session-search';
import { SEARCH_QUERY_MAX } from '@matter_extractor/shared';
import { TextField } from '@pms-digital/design-system';

/**
 * The search bar of Sessions (`recherche-sessions.md` §4), on the line of the tabs.
 *
 * The package `TextField` in its search form - the magnifier, the cross while it holds
 * something, Escape that clears it, and `busy`, which swaps the magnifier for the loading
 * ring - and nothing else of its own: 420 px wide beside the tabs, full width under them
 * below 768 px (§4.1). Its height is the package field's, at either width. It is COMMON to both tabs - the text follows the operator from Liste to
 * Matière - so the screen holds the text and this only draws it.
 *
 * The sentence « La recherche commence à deux caractères. » stands under the field
 * and OUT of the flow (`absolute`): typing the first character must not push the
 * filters down by a line, « rien ne bouge ». It is a polite status for the same
 * reason the count of results is.
 */

export interface SearchBarProps {
  readonly value: string;
  readonly onChange: (value: string) => void;
  /** A read is in flight: the spinner replaces the magnifier. */
  readonly busy: boolean;
  /** The text is there and arms no search (one character): the sentence under the field. */
  readonly belowMinimum: boolean;
}

export function SearchBar({ value, onChange, busy, belowMinimum }: SearchBarProps) {
  return (
    <div className="relative w-full md:mb-2 md:w-105 md:flex-none">
      <TextField
        label="Rechercher dans les sessions"
        hideLabel
        type="search"
        icon="search"
        data-testid={SESSIONS_TEST_IDS.search}
        placeholder="Rechercher une personne, un email, une réponse"
        value={value}
        onChange={(event) => onChange(event.currentTarget.value)}
        onClear={() => onChange('')}
        clearLabel="Effacer la recherche"
        maxLength={SEARCH_QUERY_MAX}
        busy={busy}
        busyLabel="Recherche en cours"
      />
      {belowMinimum ? (
        <output
          data-testid={SESSIONS_TEST_IDS.searchHint}
          className="absolute top-full left-0 mt-1 text-caption text-gray-700"
        >
          {SEARCH_MINIMUM_SENTENCE}
        </output>
      ) : null}
    </div>
  );
}
